import { Link as RouterLink } from 'react-router-dom';

import NotListedLocation from '@mui/icons-material/NotListedLocation';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const NotFound = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        maxWidth: '550px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <Box sx={{ mb: 3, textAlign: 'center' }}>
        <NotListedLocation sx={{ fontSize: 72 }} />
      </Box>
      <Typography variant="h3" component="h1" gutterBottom>
        Page Not Found
      </Typography>
      <Typography 
        variant="h5" 
        component="div" 
        align="center" 
        sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
      >
        The link to this page may be broken, or the page may have been removed.
      </Typography>
      <Box sx={{ mt: 4 }}>
        <Button variant="contained" color="secondary" component={RouterLink} to="/">
          Back to Application
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
